import "bootstrap/dist/css/bootstrap.css";
import './src/styles/index.scss'
import './src/components/Sidebar/Backdrop/Backdrop.css';
import "./src/components/Sidebar/SideDrawer/SideDrawer.css";
import "react-dropdown/style.css";
import { isMobile } from 'react-device-detect'

// const deviceDetect = require('react-device-detect');

// Initialize theme on client-side navigation
export const onClientEntry = () => {
  if (typeof window !== `undefined`) {
    try {
      const savedTheme = localStorage.getItem('theme');
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const theme = savedTheme || (prefersDark ? 'dark' : 'light');
      document.documentElement.setAttribute('data-theme', theme);
    } catch (e) {
      document.documentElement.setAttribute('data-theme', 'light');
    }
  }
};

export const onRouteUpdate = () => {
  if (typeof window !== `undefined`) {
    window.scrollTo(0, 0);
  }
}
